import _ from "lodash";

import { Action } from "../../../actions/actions";
import { GamesActionTypes } from "../actions/actionTypes";

import { Game } from "./game.reducer";

export function importJson(
    state: {
        unmatched_game_names: string[];
        games: Game[];
        tries: number;
        success: boolean;
        error: string;
    } = {
        unmatched_game_names: [],
        games: [],
        tries: 0,
        success: false,
        error: null
    },
    action: Action
) {
    switch (action.type) {
        case GamesActionTypes.LOAD_JSON_SUCCESS:
            return Object.assign({}, state, {
                unmatched_game_names: action.payload.unmatched_game_names.sort(),
                games: _.orderBy(action.payload.games, ["name"], ["asc"]),
                success: action.payload.unmatched_game_names.length == 0,
                tries: state.tries + 1
            });
        case GamesActionTypes.LOAD_JSON_FAIL:
            return Object.assign({}, state, {
                unmatched_game_names: [],
                games: [],
                success: false,
                error: action.payload.error,
                tries: state.tries + 1
            });
        case GamesActionTypes.LOAD_JSON_RESET:
            return Object.assign({}, state, {
                unmatched_game_names: [],
                games: [],
                success: false,
                error: null,
                tries: state.tries + 1
            });
        default:
            return state;
    }
}

export function importJsonLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case GamesActionTypes.LOAD_JSON:
            return true;

        case GamesActionTypes.LOAD_JSON_FAIL:
        case GamesActionTypes.LOAD_JSON_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function creatingAliasLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case GamesActionTypes.CREATE_ALIAS:
            return true;

        case GamesActionTypes.CREATE_ALIAS_FAIL:
        case GamesActionTypes.CREATE_ALIAS_SUCCESS:
            return false;

        default:
            return state;
    }
}
